import React, { useState, useEffect, useRef } from 'react';
import styled, { keyframes } from 'styled-components';
import ApiService from '../../services/ApiService';

const AuthToggle = styled.div`
  position: relative;
 
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  z-index: 10;
`;

const ToggleText = styled.span`
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
  margin-right: 8px;
`;

const ToggleButton = styled.button`
  background: none;
  border: none;
  color: #FFD700;
  cursor: pointer;
  text-decoration: none;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.3s ease;
  
  &:hover {
    color: #FF8C00;
    text-decoration: underline;
  }
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const sparkle = keyframes`
  0%, 100% {
    opacity: 0.3;
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(1);
  }
`;

const AuthPageContainer = styled.div`
  min-height: 100vh;
  background: black;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  position: relative;
  overflow: hidden;
  overflow-x: hidden;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 1rem;
  }

  @media (max-width: 480px) {
    padding: 0.75rem;
  }

&::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: radial-gradient(circle at 20% 80%, rgba(0, 0, 0, 0.1) 0%, transparent 50%),
                      radial-gradient(circle at 80% 20%, rgba(0, 0, 0, 0.1) 0%, transparent 50%),
                      radial-gradient(circle at 40% 40%, rgba(0, 0, 0, 0.1) 0%, transparent 50%);
    pointer-events: none;
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: radial-gradient(circle at 2% 4%, rgba(255, 255, 255, 0.26) 1px, transparent 0),
                      radial-gradient(circle at 29% 36%, rgba(255, 255, 255, 0.32) 1px, transparent 0),
                      radial-gradient(circle at 50% 60%, rgba(255, 255, 255, 0.2) 1px, transparent 0),
                      radial-gradient(circle at 80% 20%, rgba(255, 255, 255, 0.66) 1px, transparent 0),
                      radial-gradient(circle at 70% 10%, rgba(255, 255, 255, 0.11) 1px, transparent 0),
                      radial-gradient(circle at 60% 12%, rgba(255, 255, 255, 0.29) 1px, transparent 0),
                      radial-gradient(circle at 43% 90%, rgba(255, 255, 255, 0.51) 1px, transparent 0),
                      radial-gradient(circle at 32% 83%, rgba(255, 255, 255, 0.16) 1px, transparent 0),
                      radial-gradient(circle at 49% 53%, rgba(255, 255, 255, 0.6) 1px, transparent 0),
                      radial-gradient(circle at 89% 52%, rgba(255, 255, 255, 0.14) 1px, transparent 0);

    
    background-size: 25% 25%;
    pointer-events: none;
    background-repeat: repeat;
    animation: ${sparkle} 4s ease-in-out infinite;

  }
`;

const AuthCard = styled.div`
  background: rgba(30, 30, 30, 0.1);
   border: 2px solid linear-gradient(135deg, #FFD700 0%, #FF8C00 100%);
  border-radius: 20px;
  padding: 40px;
  max-width: 450px;
  width: 100%;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3), 
              0 0 0 1px rgba(0, 215, 255, 0.1),
              inset 0 1px 0 rgba(255, 255, 255, 0.1);

  animation: ${fadeIn} 0.6s ease-out;
  position: relative;
  z-index: 1;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 2rem;
    max-width: 100%;
  }

  @media (max-width: 480px) {
    padding: 1.5rem;
    border-radius: 16px;
  }

  @media (max-width: 360px) {
    padding: 1rem;
  }
`;

const TabContainer = styled.div`
  display: flex;
  margin-bottom: 30px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  padding: 4px;
`;

const Tab = styled.button`
  flex: 1;
  padding: 12px 20px;
  background: ${props => props.active ? 'linear-gradient(135deg, #FFD700 0%, #FF8C00 100%)' : 'transparent'};
  color: ${props => props.active ? '#000' : 'rgba(255, 255, 255, 0.7)'};
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 1px;

  &:hover {
    color: ${props => props.active ? '#000' : '#FFD700'};
  }
`;

const LogoSection = styled.div`
  text-align: center;
  margin-bottom: 40px;
`;

// const LogoIcon = styled.div`
//   width: 80px;
//   height: 80px;
//   margin: 0 auto 20px;
//   position: relative;
//   background: linear-gradient(135deg, #FFD700 0%, #FF8C00 50%, #FF6B35 100%);
//   border-radius: 15px;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   box-shadow: 0 10px 30px rgba(255, 215, 0, 0.3);

//   &::before {
//     content: 'GG';
//     font-size: 28px;
//     font-weight: bold;
//     color: #000;
//     text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
//   }

//   &::after {
//     content: '';
//     position: absolute;
//     bottom: -8px;
//     left: 50%;
//     transform: translateX(-50%);
//     width: 40px;
//     height: 12px;
//     background: linear-gradient(135deg, #FFD700 0%, #FF8C00 100%);
//     border-radius: 6px;
//   }
// `;


const LogoIcon = () => (
<img src="images/logofull.svg" alt="Logo" style={{ height: '256px'}} />
);

const BrandTitle = styled.h1`
  font-size: clamp(1.5rem, 5vw, 28px);
  font-weight: 700;
  color: #fff;
  margin: 0 0 8px 0;
  background: linear-gradient(135deg, #FFD700 0%, #FF8C00 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
`;

const BrandSubtitle = styled.p`
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
  margin: 0 0 30px 0;
  text-transform: uppercase;
  letter-spacing: 2px;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const InputGroup = styled.div`
  position: relative;
`;

const Input = styled.input`
  width: 100%;
  padding: 16px 20px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  color: #fff;
  font-size: clamp(14px, 2.5vw, 16px);
  transition: all 0.3s ease;
  box-sizing: border-box;
  min-height: 44px;

  &::placeholder {
    color: rgba(255, 255, 255, 0.4);
  }

  &:focus {
    outline: none;
    border-color: #667eea;
    background: rgba(255, 255, 255, 0.08);
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.2);
  }

  &:hover {
    border-color: rgba(102, 126, 234, 0.3);
  }

  &[type='date']::-webkit-calendar-picker-indicator {
    filter: brightness(0) invert(1);
    opacity: 1;
    cursor: pointer;
  }

  &[type='date'] {
    color-scheme: dark;
  }

  @media (max-width: 480px) {
    padding: 12px 16px;
  }
`;

const Button = styled.button`
  width: 100%;
  padding: 16px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 12px;
  font-size: clamp(14px, 2.5vw, 16px);
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 1px;
 
  min-height: 44px;
  box-sizing: border-box;

  &:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(102, 126, 234, 0.4);
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }

  @media (max-width: 480px) {
    padding: 12px;
  }
`;

const Error = styled.div`
  color: #ff6b6b;
  font-size: 14px;
  padding: 12px 16px;
  background: rgba(255, 107, 107, 0.1);
  border: 1px solid rgba(255, 107, 107, 0.2);
  border-radius: 8px;
  margin-top: 10px;
`;

const Success = styled.div`
  color: #51cf66;
  font-size: 14px;
  padding: 12px 16px;
  background: rgba(81, 207, 102, 0.1);
  border: 1px solid rgba(81, 207, 102, 0.2);
  border-radius: 8px;
  margin-top: 10px;
`;

const Select = styled.select`
  width: 100%;
  padding: 16px 20px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  color: #fff;
  font-size: clamp(14px, 2.5vw, 16px);
  transition: all 0.3s ease;
  box-sizing: border-box;
  cursor: pointer;
  min-height: 44px;

  &:focus {
    outline: none;
    border-color: #667eea;
    background: rgba(255, 255, 255, 0.08);
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.2);
  }

  &:hover {
    border-color: rgba(102, 126, 234, 0.3);
  }

  option {
    background: #1a1a1a;
    color: #fff;
  }

  @media (max-width: 480px) {
    padding: 12px 16px;
  }
`;

const CheckboxContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-top: 10px;
`;

const Checkbox = styled.input`
  width: 18px;
  height: 18px;
  margin-top: 2px;
  accent-color: #FFD700;
`;

const CheckboxLabel = styled.label`
  color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
  line-height: 1.4;
  cursor: pointer;

  a {
    color: #FFD700;
    text-decoration: none;
    
    &:hover {
      text-decoration: underline;
    }
  }
`;

const AchievementMessage = styled.div`
  text-align: center;
  margin-bottom: 30px;
  color: rgba(255, 255, 255, 0.8);
  font-style: italic;
`;

const PasswordInputWrapper = styled.div`
  position: relative;
`;

const PasswordToggleButton = styled.button`
  position: absolute;
  right: 15px;
  top: 7px;
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  font-size: 18px;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.3s ease;
  z-index: 2;

  &:hover {
    color: rgba(255, 255, 255, 0.8);
  }
`;

const PasswordStrengthMeter = styled.div`
  margin-top: 8px;
  height: 4px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 2px;
  overflow: hidden;
  position: relative;
`;

const PasswordStrengthBar = styled.div`
  height: 100%;
  transition: all 0.3s ease;
  width: ${props => props.$strength * 25}%;
  background: ${props => {
    if (props.$strength === 0) return 'transparent';
    if (props.$strength === 1) return '#ff4444';
    if (props.$strength === 2) return '#ffa500';
    if (props.$strength === 3) return '#ffff00';
    return '#00ff00';
  }};
`;

const PasswordStrengthText = styled.div`
  margin-top: 4px;
  font-size: 12px;
  color: ${props => {
    if (props.$strength === 0) return 'rgba(255, 255, 255, 0.4)';
    if (props.$strength === 1) return '#ff4444';
    if (props.$strength === 2) return '#ffa500';
    if (props.$strength === 3) return '#ffff00';
    return '#00ff00';
  }};
`;

const PasswordMatchIndicator = styled.div`
  margin-top: 8px;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  background: ${props => props.$match === null ? 'transparent' : props.$match ? 'rgba(0, 255, 0, 0.1)' : 'rgba(255, 68, 68, 0.1)'};
  border: 1px solid ${props => props.$match === null ? 'transparent' : props.$match ? 'rgba(0, 255, 0, 0.3)' : 'rgba(255, 68, 68, 0.3)'};
  color: ${props => props.$match === null ? 'transparent' : props.$match ? '#00ff00' : '#ff4444'};
  transition: all 0.3s ease;
  opacity: ${props => props.$match === null ? 0 : 1};
`;

const PasswordRequirements = styled.div`
  margin-top: 12px;
  padding: 12px;
  background: rgba(102, 126, 234, 0.1);
  border: 1px solid rgba(102, 126, 234, 0.3);
  border-radius: 8px;
  font-size: 12px;
`;

const RequirementTitle = styled.div`
  color: #667eea;
  font-weight: 600;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 6px;
`;

const RequirementsList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const RequirementItem = styled.li`
  display: flex;
  align-items: center;
  gap: 8px;
  color: ${props => props.$met ? '#00ff00' : 'rgba(255, 255, 255, 0.6)'};
  transition: color 0.3s ease;
  
  &::before {
    content: '${props => props.$met ? '✓' : '○'}';
    font-size: 14px;
    font-weight: bold;
  }
`;

const PasswordWarning = styled.div`
  margin-top: 8px;
  padding: 10px 12px;
  background: rgba(255, 165, 0, 0.1);
  border: 1px solid rgba(255, 165, 0, 0.3);
  border-radius: 6px;
  font-size: 12px;
  color: #ffa500;
  display: ${props => props.$show ? 'block' : 'none'};
`;

const Label = styled.label`
  display: block;
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
  margin-bottom: 8px;
  font-weight: 500;
`;

const MultiSelectContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 10px;
  margin-top: 8px;
`;

const MultiSelectOption = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid ${props => props.$checked ? '#667eea' : 'rgba(255, 255, 255, 0.1)'};
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.8);

  &:hover {
    border-color: #667eea;
    background: rgba(255, 255, 255, 0.08);
  }

  input {
    accent-color: #667eea;
  }
`;

const AvailabilityIndicator = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  margin-top: 6px;
  min-height: 20px;
  color: ${props => {
    if (props.$status === 'available') return '#10B981';
    if (props.$status === 'taken') return '#EF4444';
    if (props.$status === 'checking') return '#F59E0B';
    if (props.$status === 'error') return '#F59E0B';
    return 'transparent';
  }};
  opacity: ${props => props.$status === 'idle' ? 0 : 1};
  transition: all 0.3s ease;

  svg {
    width: 16px;
    height: 16px;
  }
`;

const InputWrapper = styled.div`
  position: relative;
`;

const Register = ({ onRegisterSuccess, authMode, setAuthMode, prefilledUsername }) => {
  const [formData, setFormData] = useState({
    username: prefilledUsername || '',
    email: '',
    password: '',
    confirmPassword: '',
    country: '',
    dateOfBirth: '',
    gamerPersona: '',
    platforms: [],
    genres: [],
    agreeToTerms: false,
    subscribeToUpdates: false
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [passwordStrength, setPasswordStrength] = useState(0);
  const [passwordRequirements, setPasswordRequirements] = useState({
    minLength: false,
    hasUpper: false,
    hasLower: false,
    hasNumber: false,
    hasSpecial: false,
    noWeirdChars: true
  });
  const [usernameAvailability, setUsernameAvailability] = useState({ status: 'idle', message: '' }); // idle, checking, available, taken
  const [emailAvailability, setEmailAvailability] = useState({ status: 'idle', message: '' });
  
  // Refs for debouncing
  const usernameCheckTimeout = useRef(null);
  const emailCheckTimeout = useRef(null);

  // Update username if prefilled value changes
  useEffect(() => {
    if (prefilledUsername) {
      setFormData(prev => ({ ...prev, username: prefilledUsername }));
    }
  }, [prefilledUsername]);

  const calculatePasswordStrength = (password) => {
    let strength = 0;
    if (password.length >= 8) strength++;
    if (/[A-Z]/.test(password)) strength++;
    if (/[0-9]/.test(password)) strength++;
    if (/[!@#$%^&*()_+\-=\x5B\x5D{};':"\\|,./?]/.test(password)) strength++;
    return strength;
  };

  // Check username availability with debouncing
  const checkUsernameAvailability = async (username) => {
    if (!username || username.length < 3) {
      setUsernameAvailability({ status: 'idle', message: '' });
      return;
    }

    setUsernameAvailability({ status: 'checking', message: 'Checking availability...' });

    try {
      const isAvailable = await ApiService.checkUsernameAvailability(username);
      if (isAvailable) {
        setUsernameAvailability({ status: 'available', message: 'Username is available' });
      } else {
        setUsernameAvailability({ status: 'taken', message: 'Username is already taken' });
      }
    } catch (error) {
      console.error('Error checking username:', error);
      setUsernameAvailability({ status: 'error', message: 'Could not verify availability' });
    }
  };

  // Check email availability with debouncing
  const checkEmailAvailability = async (email) => {
    const normalizedEmail = String(email || '').trim().toLowerCase();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!normalizedEmail || !emailRegex.test(normalizedEmail)) {
      setEmailAvailability({ status: 'idle', message: '' });
      return;
    }

    setEmailAvailability({ status: 'checking', message: 'Checking availability...' });

    try {
      const isAvailable = await ApiService.checkEmailAvailability(normalizedEmail);
      if (isAvailable) {
        setEmailAvailability({ status: 'available', message: 'Email is available' });
      } else {
        setEmailAvailability({ status: 'taken', message: 'Email is already registered' });
      }
    } catch (error) {
      console.error('Error checking email:', error);
      setEmailAvailability({ status: 'error', message: 'Could not verify availability' });
    }
  };

  const getPasswordStrengthText = (strength) => {
    if (strength === 0) return '';
    if (strength === 1) return 'Weak';
    if (strength === 2) return 'Fair';
    if (strength === 3) return 'Good';
    return 'Strong';
  };

  const checkPasswordRequirements = (password) => {
    // Allowed special characters: !@#$%^&*()_+-=[]{};':"\\|,./? (NO < > for XSS protection)
    const allowedSpecialChars = /^[A-Za-z0-9!@#$%^&*()_+\-=\x5B\x5D{};':"\\|,./?]*$/;
    
    const requirements = {
      minLength: password.length >= 8,
      hasUpper: /[A-Z]/.test(password),
      hasLower: /[a-z]/.test(password),
      hasNumber: /[0-9]/.test(password),
      hasSpecial: /[!@#$%^&*()_+\-=\x5B\x5D{};':"\\|,./?]/.test(password),
      noWeirdChars: allowedSpecialChars.test(password)
    };
    
    setPasswordRequirements(requirements);
    return requirements;
  };

  const isPasswordValid = () => {
    return passwordRequirements.minLength &&
           passwordRequirements.hasUpper &&
           passwordRequirements.hasLower &&
           passwordRequirements.hasNumber &&
           passwordRequirements.hasSpecial &&
           passwordRequirements.noWeirdChars &&
           passwordStrength === 4; // Require "Strong" strength (all 4 criteria)
  };

  const checkPasswordMatch = () => {
    if (!formData.confirmPassword) return null;
    return formData.password === formData.confirmPassword;
  };

  const validatePassword = (password) => {
    const requirements = checkPasswordRequirements(password);
    return requirements.minLength && 
           requirements.hasUpper && 
           requirements.hasLower &&
           requirements.hasNumber && 
           requirements.hasSpecial &&
           requirements.noWeirdChars;
  };

  const sanitizePasswordInput = (value) => {
    // Remove any characters that aren't letters, numbers, or allowed special chars (NO < > for XSS protection)
    return value.replace(/[^A-Za-z0-9!@#$%^&*()_+\-=\x5B\x5D{};':"\\|,./?]/g, '');
  };

  const sanitizeEmail = (value) => {
    // Email: only allow valid email characters
    return value.replace(/[^A-Za-z0-9@._-]/g, '');
  };

  const sanitizeUsername = (value) => {
    // Username: only allow alphanumeric, underscore, hyphen
    return value.replace(/[^A-Za-z0-9_-]/g, '');
  };

  const sanitizeGeneralInput = (value) => {
    // Remove SQL injection and XSS attack characters
    return value.replace(/[<>"'`;\\]/g, '');
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    // Sanitize based on field type
    let sanitizedValue = value;
    if (name === 'password' || name === 'confirmPassword') {
      sanitizedValue = sanitizePasswordInput(value);
    } else if (name === 'email') {
      sanitizedValue = sanitizeEmail(value);
    } else if (name === 'username') {
      sanitizedValue = sanitizeUsername(value);
    } else if (name === 'country' || name === 'gamerPersona') {
      // Dropdowns are safe, no sanitization needed
      sanitizedValue = value;
    } else {
      // General text fields (dateOfBirth, etc.)
      sanitizedValue = sanitizeGeneralInput(value);
    }
    
    setFormData({
      ...formData,
      [name]: sanitizedValue
    });

    // Update password strength and requirements when password changes
    if (name === 'password') {
      checkPasswordRequirements(sanitizedValue);
      setPasswordStrength(calculatePasswordStrength(sanitizedValue));
    }

    // Check username availability with debouncing (500ms delay)
    if (name === 'username') {
      if (usernameCheckTimeout.current) {
        clearTimeout(usernameCheckTimeout.current);
      }
      if (sanitizedValue.length >= 3) {
        usernameCheckTimeout.current = setTimeout(() => {
          checkUsernameAvailability(sanitizedValue);
        }, 500);
      } else {
        setUsernameAvailability({ status: 'idle', message: '' });
      }
    }

    // Check email availability with debouncing (500ms delay)
    if (name === 'email') {
      if (emailCheckTimeout.current) {
        clearTimeout(emailCheckTimeout.current);
      }
      const normalizedEmail = String(sanitizedValue || '').trim().toLowerCase();
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (emailRegex.test(normalizedEmail)) {
        emailCheckTimeout.current = setTimeout(() => {
          checkEmailAvailability(normalizedEmail);
        }, 500);
      } else {
        setEmailAvailability({ status: 'idle', message: '' });
      }
    }
  };

  const handleCheckboxChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.checked
    });
  };

  const handleMultiSelectChange = (field, value) => {
    setFormData(prev => {
      const currentValues = prev[field];
      const newValues = currentValues.includes(value)
        ? currentValues.filter(v => v !== value)
        : [...currentValues, value];
      return { ...prev, [field]: newValues };
    });
  };

  const getMaxDateOfBirth = () => {
    const maxDate = new Date();
    maxDate.setFullYear(maxDate.getFullYear() - 13);
    const year = maxDate.getFullYear();
    const month = String(maxDate.getMonth() + 1).padStart(2, '0');
    const day = String(maxDate.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const maxDateOfBirth = getMaxDateOfBirth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    // Check username availability
    if (usernameAvailability.status === 'taken') {
      setError('Username is already taken. Please choose a different username.');
      setLoading(false);
      return;
    }

    // Check email availability
    if (emailAvailability.status === 'taken') {
      setError('Email is already registered. Please use a different email or try logging in.');
      setLoading(false);
      return;
    }

    // Wait for availability checks to complete if still checking
    if (usernameAvailability.status === 'checking' || emailAvailability.status === 'checking') {
      setError('Please wait while we verify your username and email availability.');
      setLoading(false);
      return;
    }

    // Check if password meets minimum strength requirement
    if (passwordStrength < 4) {
      setError('Password is too weak. Please create a stronger password ("Strong" required - all criteria must be met)');
      setLoading(false);
      return;
    }

    // Comprehensive password validation
    if (!validatePassword(formData.password)) {
      setError('Password must contain: 8+ characters, uppercase, lowercase, number, and special character');
      setLoading(false);
      return;
    }

    // Check for invalid characters
    if (!passwordRequirements.noWeirdChars) {
      setError('Password contains invalid characters. Use only letters, numbers, and standard symbols');
      setLoading(false);
      return;
    }

    if (formData.password !== formData.confirmPassword) {
      setError('Passwords do not match');
      setLoading(false);
      return;
    }

    if (!formData.agreeToTerms) {
      setError('Please agree to the Terms of Service and Privacy Policy');
      setLoading(false);
      return;
    }

    if (!formData.dateOfBirth || formData.dateOfBirth > maxDateOfBirth) {
      setError('You must be at least 13 years old to register.');
      setLoading(false);
      return;
    }

    try {
      // Prepare metadata with all additional fields
      const metadata = {
        country: formData.country,
        dateOfBirth: formData.dateOfBirth,
        gamerPersona: formData.gamerPersona,
        platforms: formData.platforms,
        genres: formData.genres,
        subscribeToUpdates: formData.subscribeToUpdates
      };

      console.log('📝 Registration data:', {
        username: formData.username,
        email: formData.email,
        metadata: metadata
      });

      // Step 1: Register user with basic fields (Strapi default)
      const response = await ApiService.register({
        username: formData.username,
        email: formData.email,
        password: formData.password
      });

      console.log('✅ User registered:', response);

      // Step 2: Update user metadata if registration was successful
      if (response && response.user && response.user.id) {
        try {
          await ApiService.updateUser(response.user.id, { metadata });
          console.log('✅ User metadata updated (secure)');
        } catch (metadataError) {
          console.warn('⚠️ Could not update metadata, but registration successful:', metadataError);
        }
      }
      
      setSuccess('Registration successful! Redirecting to login...');
      console.log('✅ Registration successful, redirecting with username:', formData.username);
      
      // Redirect to login after 2 seconds with username prefilled
      setTimeout(() => {
        setAuthMode('login');
        if (onRegisterSuccess) {
          onRegisterSuccess(formData.username);
        }
      }, 2000);
    } catch (error) {
      setError(error.response?.data?.message || 'Registration failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthPageContainer>
      <AuthCard>
        <LogoSection>
          <LogoIcon />
          <BrandSubtitle>GAMERS REDEMPTION PORTAL</BrandSubtitle>
        </LogoSection>

        <TabContainer>
          <Tab active={authMode === 'login'} onClick={() => setAuthMode('login')}>LOG IN</Tab>
          <Tab active={authMode === 'register'} onClick={() => setAuthMode('register')}>REGISTER</Tab>
        </TabContainer>

        <AchievementMessage>
          Your Achievement is Unlocked.<br />
          Your Rewards Await.
        </AchievementMessage>
        
        <Form onSubmit={handleSubmit}>
          <InputGroup>
            <InputWrapper>
              <Input
                type="email"
                name="email"
                placeholder="Email Address"
                value={formData.email}
                onChange={handleChange}
                required
              />
              <AvailabilityIndicator $status={emailAvailability.status}>
                {emailAvailability.status === 'checking' && (
                  <>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <circle cx="12" cy="12" r="10" strokeWidth="2" strokeDasharray="32" strokeDashoffset="0">
                        <animateTransform attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur="1s" repeatCount="indefinite"/>
                      </circle>
                    </svg>
                    <span>{emailAvailability.message}</span>
                  </>
                )}
                {emailAvailability.status === 'available' && (
                  <>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
                      <path d="M20 6L9 17l-5-5"/>
                    </svg>
                    <span>{emailAvailability.message}</span>
                  </>
                )}
                {emailAvailability.status === 'taken' && (
                  <>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
                      <path d="M18 6L6 18M6 6l12 12"/>
                    </svg>
                    <span>{emailAvailability.message}</span>
                  </>
                )}
                {emailAvailability.status === 'error' && (
                  <>
                    <span>⚠️</span>
                    <span>{emailAvailability.message}</span>
                  </>
                )}
              </AvailabilityIndicator>
            </InputWrapper>
          </InputGroup>
          
          <InputGroup>
            <PasswordInputWrapper>
              <Input
                type={showPassword ? 'text' : 'password'}
                name="password"
                placeholder="Create Password"
                value={formData.password}
                onChange={handleChange}
                required
              />
              <PasswordToggleButton
                type="button"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? '👁️' : '👁️‍🗨️'}
              </PasswordToggleButton>
            </PasswordInputWrapper>
            {formData.password && (
              <>
                <PasswordStrengthMeter>
                  <PasswordStrengthBar $strength={passwordStrength} />
                </PasswordStrengthMeter>
                <PasswordStrengthText $strength={passwordStrength}>
                  {getPasswordStrengthText(passwordStrength)}
                </PasswordStrengthText>
              </>
            )}
            <PasswordRequirements>
              <RequirementTitle>
                <span>🔒</span>
                <span>Password Requirements</span>
              </RequirementTitle>
              <RequirementsList>
                <RequirementItem $met={passwordRequirements.minLength}>
                  At least 8 characters
                </RequirementItem>
                <RequirementItem $met={passwordRequirements.hasUpper}>
                  One uppercase letter (A-Z)
                </RequirementItem>
                <RequirementItem $met={passwordRequirements.hasLower}>
                  One lowercase letter (a-z)
                </RequirementItem>
                <RequirementItem $met={passwordRequirements.hasNumber}>
                  One number (0-9)
                </RequirementItem>
                <RequirementItem $met={passwordRequirements.hasSpecial}>
                  One special character (!@#$%^&*...)
                </RequirementItem>
                <RequirementItem $met={passwordRequirements.noWeirdChars}>
                  Only standard characters allowed
                </RequirementItem>
              </RequirementsList>
            </PasswordRequirements>
            <PasswordWarning $show={formData.password && passwordStrength < 4}>
              ⚠️ Password must be "Strong" (all requirements met) to register
            </PasswordWarning>
          </InputGroup>
          
          <InputGroup>
            <PasswordInputWrapper>
              <Input
                type={showConfirmPassword ? 'text' : 'password'}
                name="confirmPassword"
                placeholder="Confirm Password"
                value={formData.confirmPassword}
                onChange={handleChange}
                required
              />
              <PasswordToggleButton
                type="button"
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              >
                {showConfirmPassword ? '👁️' : '👁️‍🗨️'}
              </PasswordToggleButton>
            </PasswordInputWrapper>
            <PasswordMatchIndicator $match={checkPasswordMatch()}>
              {checkPasswordMatch() === null ? '' : checkPasswordMatch() ? (
                <>
                  <span>✓</span>
                  <span>Passwords match</span>
                </>
              ) : (
                <>
                  <span>✗</span>
                  <span>Passwords do not match</span>
                </>
              )}
            </PasswordMatchIndicator>
          </InputGroup>

          <InputGroup>
            <InputWrapper>
              <Input
                type="text"
                name="username"
                placeholder="Public Username (Gamertag)"
                value={formData.username}
                onChange={handleChange}
                required
              />
              <AvailabilityIndicator $status={usernameAvailability.status}>
                {usernameAvailability.status === 'checking' && (
                  <>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <circle cx="12" cy="12" r="10" strokeWidth="2" strokeDasharray="32" strokeDashoffset="0">
                        <animateTransform attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur="1s" repeatCount="indefinite"/>
                      </circle>
                    </svg>
                    <span>{usernameAvailability.message}</span>
                  </>
                )}
                {usernameAvailability.status === 'available' && (
                  <>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
                      <path d="M20 6L9 17l-5-5"/>
                    </svg>
                    <span>{usernameAvailability.message}</span>
                  </>
                )}
                {usernameAvailability.status === 'taken' && (
                  <>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
                      <path d="M18 6L6 18M6 6l12 12"/>
                    </svg>
                    <span>{usernameAvailability.message}</span>
                  </>
                )}
                {usernameAvailability.status === 'error' && (
                  <>
                    <span>⚠️</span>
                    <span>{usernameAvailability.message}</span>
                  </>
                )}
              </AvailabilityIndicator>
            </InputWrapper>
          </InputGroup>

          <InputGroup>
            <Select
              name="country"
              value={formData.country}
              onChange={handleChange}
              required
            >
              <option value="">Select Country/Region</option>
              <option value="AE">🇦🇪 United Arab Emirates</option>
              <option value="SA">🇸🇦 Saudi Arabia</option>
              <option value="QA">🇶🇦 Qatar</option>
              <option value="KW">🇰🇼 Kuwait</option>
              <option value="BH">🇧🇭 Bahrain</option>
              <option value="OM">🇴🇲 Oman</option>
              <option value="LB">🇱🇧 Lebanon</option>
              <option value="JO">🇯🇴 Jordan</option>
              <option value="EG">🇪🇬 Egypt</option>
              <option disabled>──────────</option>
              <option value="US">🇺🇸 United States</option>
              <option value="CA">🇨🇦 Canada</option>
              <option value="GB">🇬🇧 United Kingdom</option>
              <option value="AU">🇦🇺 Australia</option>
              <option value="DE">🇩🇪 Germany</option>
              <option value="FR">🇫🇷 France</option>
              <option value="JP">🇯🇵 Japan</option>
              <option value="KR">🇰🇷 South Korea</option>
              <option value="BR">🇧🇷 Brazil</option>
              <option value="MX">🇲🇽 Mexico</option>
              <option value="IN">🇮🇳 India</option>
              <option value="other">Other</option>
            </Select>
          </InputGroup>

          <InputGroup>
            <Label>Date of Birth</Label>
            <Input
              type="date"
              name="dateOfBirth"
              value={formData.dateOfBirth}
              onChange={handleChange}
              max={maxDateOfBirth}
              required
            />
          </InputGroup>

          <InputGroup>
            <Label>Gamer Persona</Label>
            <Select
              name="gamerPersona"
              value={formData.gamerPersona}
              onChange={handleChange}
              required
            >
              <option value="">Select Your Gamer Type</option>
              <option value="casual">🎮 Casual - Play for fun</option>
              <option value="grinder">💪 Grinder - Dedicated player</option>
              <option value="pro">🏆 Pro - Competitive player</option>
              <option value="streamer">📺 Streamer - Content creator</option>
            </Select>
          </InputGroup>

          <InputGroup>
            <Label>Preferred Platforms (Select all that apply)</Label>
            <MultiSelectContainer>
              <MultiSelectOption $checked={formData.platforms.includes('pc')}>
                <input
                  type="checkbox"
                  checked={formData.platforms.includes('pc')}
                  onChange={() => handleMultiSelectChange('platforms', 'pc')}
                />
                <span>💻 PC</span>
              </MultiSelectOption>
              <MultiSelectOption $checked={formData.platforms.includes('ps5')}>
                <input
                  type="checkbox"
                  checked={formData.platforms.includes('ps5')}
                  onChange={() => handleMultiSelectChange('platforms', 'ps5')}
                />
                <span>🎮 PlayStation</span>
              </MultiSelectOption>
              <MultiSelectOption $checked={formData.platforms.includes('xbox')}>
                <input
                  type="checkbox"
                  checked={formData.platforms.includes('xbox')}
                  onChange={() => handleMultiSelectChange('platforms', 'xbox')}
                />
                <span>🎮 Xbox</span>
              </MultiSelectOption>
              <MultiSelectOption $checked={formData.platforms.includes('switch')}>
                <input
                  type="checkbox"
                  checked={formData.platforms.includes('switch')}
                  onChange={() => handleMultiSelectChange('platforms', 'switch')}
                />
                <span>🎮 Switch</span>
              </MultiSelectOption>
              <MultiSelectOption $checked={formData.platforms.includes('mobile')}>
                <input
                  type="checkbox"
                  checked={formData.platforms.includes('mobile')}
                  onChange={() => handleMultiSelectChange('platforms', 'mobile')}
                />
                <span>📱 Mobile</span>
              </MultiSelectOption>
            </MultiSelectContainer>
          </InputGroup>

          <InputGroup>
            <Label>Favorite Genres (Select all that apply)</Label>
            <MultiSelectContainer>
              <MultiSelectOption $checked={formData.genres.includes('fps')}>
                <input
                  type="checkbox"
                  checked={formData.genres.includes('fps')}
                  onChange={() => handleMultiSelectChange('genres', 'fps')}
                />
                <span>🔫 FPS</span>
              </MultiSelectOption>
              <MultiSelectOption $checked={formData.genres.includes('rpg')}>
                <input
                  type="checkbox"
                  checked={formData.genres.includes('rpg')}
                  onChange={() => handleMultiSelectChange('genres', 'rpg')}
                />
                <span>⚔️ RPG</span>
              </MultiSelectOption>
              <MultiSelectOption $checked={formData.genres.includes('moba')}>
                <input
                  type="checkbox"
                  checked={formData.genres.includes('moba')}
                  onChange={() => handleMultiSelectChange('genres', 'moba')}
                />
                <span>🏟️ MOBA</span>
              </MultiSelectOption>
              <MultiSelectOption $checked={formData.genres.includes('sports')}>
                <input
                  type="checkbox"
                  checked={formData.genres.includes('sports')}
                  onChange={() => handleMultiSelectChange('genres', 'sports')}
                />
                <span>⚽ Sports</span>
              </MultiSelectOption>
              <MultiSelectOption $checked={formData.genres.includes('racing')}>
                <input
                  type="checkbox"
                  checked={formData.genres.includes('racing')}
                  onChange={() => handleMultiSelectChange('genres', 'racing')}
                />
                <span>🏎️ Racing</span>
              </MultiSelectOption>
              <MultiSelectOption $checked={formData.genres.includes('strategy')}>
                <input
                  type="checkbox"
                  checked={formData.genres.includes('strategy')}
                  onChange={() => handleMultiSelectChange('genres', 'strategy')}
                />
                <span>♟️ Strategy</span>
              </MultiSelectOption>
            </MultiSelectContainer>
          </InputGroup>

          <CheckboxContainer>
            <Checkbox
              type="checkbox"
              id="agreeToTerms"
              name="agreeToTerms"
              checked={formData.agreeToTerms}
              onChange={handleCheckboxChange}
              required
            />
            <CheckboxLabel htmlFor="agreeToTerms">
              I agree to <a href="/terms" target="_blank">Terms of Service</a> and <a href="/privacy" target="_blank">Privacy Policy</a>
            </CheckboxLabel>
          </CheckboxContainer>

          <CheckboxContainer>
            <Checkbox
              type="checkbox"
              id="subscribeToUpdates"
              name="subscribeToUpdates"
              checked={formData.subscribeToUpdates}
              onChange={handleCheckboxChange}
            />
            <CheckboxLabel htmlFor="subscribeToUpdates">
              Keep me updated with the latest GG Trophy news and exclusive offers.
            </CheckboxLabel>
          </CheckboxContainer>
          
          <Button 
            type="submit" 
            disabled={
              loading || 
              !isPasswordValid() || 
              !checkPasswordMatch() || 
              usernameAvailability.status === 'taken' || 
              emailAvailability.status === 'taken' ||
              usernameAvailability.status === 'checking' ||
              emailAvailability.status === 'checking'
            }
          >
            {loading ? 'Creating Account...' : 'Create Account'}
          </Button>
                  <AuthToggle>
          {authMode === 'login' ? (
            <>
              <ToggleText>Don't have an account?</ToggleText>
              <ToggleButton onClick={() => setAuthMode('register')}>
                Create Account
              </ToggleButton>
            </>
          ) : (
            <>
              <ToggleText>Already have an account?</ToggleText>
              <ToggleButton onClick={() => setAuthMode('login')}>
                Sign In
              </ToggleButton>
            </>
          )}
        </AuthToggle>
          {error && <Error>{error}</Error>}
          {success && <Success>{success}</Success>}
        </Form>
      </AuthCard>
    </AuthPageContainer>
  );
};

export default Register;